<script>
  export let currentRoutePath = null;
  export let config = null;
</script>
<slot/>